import { useContext } from "react";
import { LayoutContext } from "./Layout";

const useLayout = () => {
	return useContext(LayoutContext);
};

export default useLayout;
